import React, { useEffect } from "react";
import { Loader2, ExternalLink } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { BRAND } from "@/data/content";

const SOFTWARE_URL = "https://www.sav-sys.com";

export default function AccountingSoftware() {
  const { t } = useLang();

  useEffect(() => {
    const timer = setTimeout(() => window.location.replace(SOFTWARE_URL), 500);
    return () => clearTimeout(timer);
  }, []);

  return (
    <div className="min-h-[70vh] grid place-items-center bg-ivory px-6" data-testid="accounting-software-redirect">
      <div className="text-center max-w-md">
        <Loader2 className="h-10 w-10 text-navy animate-spin mx-auto" />
        <h1 className="font-display text-3xl text-ink mt-6">
          {t({ en: "Opening the Accounting Software…", ar: "جارٍ فتح برنامج الحسابات…" })}
        </h1>
        <p className="mt-3 text-muted leading-relaxed">
          {t({
            en: `You're being taken to ${BRAND.short.en}'s accounting software portal.`,
            ar: "يتم تحويلك إلى بوابة برنامج الحسابات الخاص بنا.",
          })}
        </p>
        <a
          href={SOFTWARE_URL}
          target="_blank"
          rel="noopener noreferrer"
          data-testid="software-manual-link"
          className="mt-6 inline-flex items-center gap-2 h-12 px-7 rounded-full bg-navy text-white font-semibold hover:bg-navy-600 transition-colors"
        >
          <ExternalLink className="h-4 w-4" />
          {t({ en: "Click here if not redirected", ar: "اضغط هنا إذا لم يتم التحويل" })}
        </a>
      </div>
    </div>
  );
}
